<template>
    <div>

    </div>
</template>

<script>
export default {
    mounted(){
        this.logout();
    },
    methods: {
        logout() {
            //window.Bugpilot.logout();
            this.$store.commit('SET_PRODUCT_TYPE', null);
            this.removeCarItems();
        },
        async removeCarItems() {
            await this.$store.dispatch('cart/list').then((res) => {
                res.items.forEach((elem) => {
                    this.removeCartItem(elem.id)
                })
                this.$store.dispatch('logout');
            });
        },
    },
};
</script>

